/*
 * @Author: your name
 * @Date: 2022-04-22 16:04:09
 * @LastEditTime: 2022-04-26 14:28:15
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \app\src\main.js
 */
import Vue from 'vue'
import App from './App'
import store from './store'
import { router, updatePageTitle } from './router'
import i18n from './i18n/index'
import VueI18n from 'vue-i18n'
import Module from './utils/Module'
import './styles/index.less'
import VueClipboard from 'vue-clipboard2'
import '@/assets/iconfonts/iconfont.css'
import { Api } from '@/api'
import EventBus from '@/utils/EventBus';
import languageMixin from '@/utils/languageMixmin';

Vue.mixin(languageMixin);
Vue.prototype.$eventBus = EventBus;


Vue.use(VueClipboard)
import map from './utils/map'
Vue.prototype.$map = map;

import { cookie } from '@/utils/tools'

import { Loading, Locale } from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import thTH from 'vant/lib/locale/lang/th-TH'
import { DropdownMenu, DropdownItem } from 'vant'
import verConfig, { ver } from '@/utils/verConfig'
import toFixed from '@/utils/toFixed'
import hasPaypass from './utils/hasPaypass'
import format from "./utils/format"
import formatMoney from './utils/formatMoney'
import Img from "./utils/ImgFormat"
import fixed from './utils/fixed'
import { Trans } from "@tt/components"
import { isLinkGame } from '@/utils/request'
import antiShake from '@/utils/anti-shake'


const isDownloadFn = true
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Loading)
Vue.prototype.module = Module
Vue.prototype.$cookie = cookie
Vue.prototype.$api = Api;
Vue.prototype.$store = store;
Vue.prototype.$isDownloadFn = isDownloadFn;
Vue.prototype.verConfig = verConfig;
Vue.prototype.ver = ver;
Vue.prototype.toFixed = toFixed;
Vue.prototype.hasPaypass = hasPaypass;
Vue.prototype.$format = format;
Vue.prototype.$money = formatMoney;
Vue.prototype.$img = Img;
Vue.prototype.fixed = fixed;
Vue.component('trans', Trans)
Vue.prototype.$isLinkGame = isLinkGame
Vue.prototype.$submitOnce = function(key, task) {
  return antiShake.submitOnce(this, key, task)
}


Vue.filter("lan", (val) => i18n.t(val));

Vue.use(VueI18n, {
  i18n: (key, value) => i18n.t(key, value),
})

// 动态改标题
document.getElementsByTagName('title')[0].innerText = verConfig.title;
// 动态改图标
const icoLink = document.createElement('link');
icoLink.type = 'image/png';
icoLink.rel = 'icon';
const icon = ver;
icoLink.href = require(`@/assets/ico/${icon}.png`);
document.head.appendChild(icoLink);

// router.beforeEach((to, from, next) => {
//   if (to.meta.login) {
//     if (!cookie.get('token')) {
//       router.replace("login");
//       return
//     }
//   }
//   next()
// })

new Vue({
  router,
  store,
  i18n,
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler(language) {
        Locale.use(language, {
          ...({ en: enUS, zh: zhCN, th: thTH }[language] || enUS),
          loading: i18n.t('Hint.loading'),
          confirm: i18n.t('Button.confirm'),
          cancel: i18n.t('Button.cancle'),
        })
        updatePageTitle(this.$route)
      },
    },
  },
  el: '#app',
  render: (h) => h(App),
})
